import React, { useState } from 'react';

import Table from '~components/molecules/Table';
import Text from '~components/atoms/Text';

import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum, MetalTypeEnum } from '~utils/enums';

import UtilFunctions from '~utils/functions';
import * as Styles from './InventoryReportTable.module.scss';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import ActionButton from '~components/atoms/ActionButton';
import InventoryDeliveredReportTablePaginator from '../InventoryDeliveredReportTablePaginator';
import Image from '~components/atoms/Image';

const InventoryDeliveredReportTable = () => {
    const {
        Misc: {
            renderTransactionStatusChip,
            dateTimeFormat,
        },
    } = UtilFunctions; 

    const inventoryDeliveredReportListing = useAppSelector(state => state.report.inventoryReport.inventoryDeliveredReportTransactionListing.data);

    const isLoading = useAppSelector(state => state.report.loadings.getInventoryDeliveredReportTransactionListing);
    const isError = useAppSelector(state => state.report.errors.getInventoryDeliveredReportTransactionListing);

    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);
    const [serialNoList, setSerialNoList] = useState<string[]>([]);

    const tableHeader = [
        'IMAGE',
        'PRODUCT NAME',
        'METAL TYPE',
        'BRANCH',
        'DELIVERY TO',
        'SERIAL NUMBER',
        'QUANTITY',
        'TOTAL WEIGHT (G)',
        'FUND TYPE',
        'DELIVERED AT',
    ];

    const tableBody = inventoryDeliveredReportListing.map(transaction => {
        const {
            transferId,
            productName,
            metalType,
            branch,
            deliveredTo,
            serialNumbers,
            quantity,
            totalWeight,
            fundType,
            deliveredAt,
            image,
        } = transaction;

        const handleViewSerialNo = () => {
            if (!serialNumbers) return;

            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNumbers);
        };

        const renderSerialNo = () => {
            if (!serialNumbers) return '-';

            return (
                <ActionButton
                    key={transferId}
                    label='View'
                    onClick={handleViewSerialNo}
                />
            );
        };

        return {
            cells: [
                <Image
                    key={transferId}
                    src={image || ''}
                    width={40}
                    height={40}
                />,
                productName,
                MetalTypeEnum[metalType],
                branch?.branchName,
                deliveredTo?.branchName,
                renderSerialNo(),
                quantity,
                totalWeight.toFixed(3),
                FundTypeEnum[fundType],
                deliveredAt ? dateTimeFormat(deliveredAt) : '-',
            ],
        }
    });

    return (
        <>
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoading}
                error={isError}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />

            <InventoryDeliveredReportTablePaginator />
        </>
    );
};

export default InventoryDeliveredReportTable;
